import { COLORS } from '~/data/ui/colors';

export const MenuItemStyle = {
  direction: 'rtl',
  margin: '0 8px',
  '&:hover': {
    backgroundColor: COLORS.primary.light2,
    borderRadius: '6px',
  },
};

export const iconStyles = {
  '& svg': {
    maxWidth: '21px',
    maxHeight: '21px',
  },
};
